$(document).ready(function(){ 
  $("button.text-clear-icon").click(function() {
       $("#boost-pfs-search-box-1").val(" ");        
  });
  
  $(".search-close-button").on("click",function(){
    $('#boost-pfs-search-box-2').val('');
    $('#Search-In-Template').val(" ");
    history.pushState({data:true}, 'q', 'search');
    document.location.reload(true); 
  });
 
  var pprice = $(".price-item.price-item--regular").text().trim()
     var pri = pprice.split(" "); 
     let final_price = pri[0];
     $(".price-item.price-item--regular").text(final_price);   
        
  var pprices = $(".price-item.price-item--sale").text().trim()
     var pris = pprices.split(" "); 
     let final_prices = pris[0];
     $(".price-item.price-item--sale").text(final_prices);   
});


if ($(window).width() > 767) {
    $( window ).on("load", function() {
     $('.boost-pfs-filter-tree-desktop-button button').click();
    });
}  

$(document).ready(function() {
    $( "#Search-In-Modal-1" ).keypress(function() {
      $("#label-search-modal").css("display", "none");
    });
    $( "#Search-In-Modal-1" ).keyup(function() {
      var v = $("#boost-pfs-search-box-0").val().length;
      if( v === 0 ){
 		$("#label-search-modal").css("display", "block");
      }else{
        $("#label-search-modal").css("display", "none");
      }
    });
});

$(document).ready(function() {
    $( "#Search-In-Modal-mobile" ).keypress(function() {
      $("#label-search-modal-mobile").css("display", "none");
    });
    $( "#Search-In-Modal-mobile" ).keyup(function() {
      var v = $("#boost-pfs-search-box-1").val().length;
      if( v === 0 ){
 		$("#label-search-modal-mobile").css("display", "block");
      }else{
        $("#label-search-modal-mobile").css("display", "none");
      }
    });
});
